import {
  Card,
  CardContent,
  Typography,
  Grid,
  Box,
  Divider,
} from "@mui/material";

import LocationOnIcon from "@mui/icons-material/LocationOn";
import PhoneIcon from "@mui/icons-material/Phone";
import EmailIcon from "@mui/icons-material/Email";
import PersonIcon from "@mui/icons-material/Person";
import AssignmentIndIcon from "@mui/icons-material/AssignmentInd";
import localize from "../../../common/localize";
import { TimeToLeave } from "@mui/icons-material";

const InfoItem = ({ icon, label, value }) => (
  <Box display="flex" alignItems="flex-start" gap={1.5} mb={2}>
    {icon}
    <Box>
      <Typography variant="caption" color="text.secondary">
        {label}
      </Typography>

      <Typography variant="body1" sx={{ fontWeight: 500 }}>
        {value}
      </Typography>
    </Box>
  </Box>
);

export default function EventClientDatadetails({ data }) {
  return (
    <Card
      sx={{
        borderRadius: 2,
        p: 2,
        background: "#fdfdff",
        variant: "outlined",
        width: "100%",
      }}
    >
      <CardContent>
        <Box
          sx={{
            display: "grid",
            gridTemplateColumns: "repeat(auto-fit, minmax(300px, 1fr))",
            gap: 3,
          }}
        >
          <Box>
            {/* IDENTIFICACIÓN */}
            <Grid item xs={8} md={6}>
              <Typography variant="subtitle1" sx={{ fontWeight: 600, mb: 2 }}>
                {localize.identification}
              </Typography>

              <InfoItem
                icon={<LocationOnIcon color="primary" />}
                label={localize.identification_type}
                value={data?.identificationType}
              />

              <InfoItem
                icon={<LocationOnIcon color="primary" />}
                label={localize.identification}
                value={data?.identification}
              />

              <InfoItem
                icon={<LocationOnIcon color="primary" />}
                label={localize.name}
                value={data?.name}
              />
            </Grid>
          </Box>

          <Box>
            {/* CONTACTO */}
            <Grid item xs={8} md={6}>
              <Typography variant="subtitle1" sx={{ fontWeight: 600, mb: 2 }}>
                {localize.contact}
              </Typography>

              <InfoItem
                icon={<PhoneIcon color="success" />}
                label={localize.phone_number}
                value={data?.phoneNumber}
              />

              <InfoItem
                icon={<EmailIcon color="secondary" />}
                label={localize.email}
                value={data?.email}
              />

              <InfoItem
                icon={<PersonIcon />}
                label={localize.contact_name}
                value={data?.contactName}
              />
            </Grid>
          </Box>

          <Box>
            {/* DIRECCIÓN */}
            <Grid item xs={8} md={6}>
              <Typography variant="subtitle1" sx={{ fontWeight: 600, mb: 2 }}>
                {localize.location}
              </Typography>

              <InfoItem
                icon={<AssignmentIndIcon color="info" />}
                label={localize.address}
                value={data?.address}
                isComponent
              />

              <InfoItem
                icon={<PersonIcon />}
                label={localize.city}
                value={data?.city}
              />

              <InfoItem
                icon={<TimeToLeave />}
                label={localize.department}
                value={data?.department}
              />
            </Grid>
          </Box>
        </Box>
      </CardContent>
    </Card>
  );
}
